<app-strategy-list [campaignType]="'TacosStrategy'" (strategyCreationClick)="createStrategy()"></app-strategy-list>
